module.exports = __webpack_public_path__ + "static/media/msg2.026b52a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/msg2.mp3
// module id = mP9R
// module chunks = 1